import type { BillingRegion } from '~/types/locale'

export const billingRegions: BillingRegion[] = [
  {
    region: 'NA',
    billingAddressConfig: {
      fields: [
        { name: 'addressLine1', 'data-recurly': 'address1', type: 'text', line: 1, rules: { required: true, max: 30, su_cc: { reverse: true } } },
        { name: 'addressLine2', 'data-recurly': 'address2', type: 'text', line: 2, rules: { required: false, max: 30, su_cc: { reverse: true } } },
        { name: 'city', 'data-recurly': 'city', type: 'text', line: 4, rules: { required: true, max: 25, su_address: true, su_cc: { reverse: true } } },
        { name: 'region', type: 'state', 'data-recurly': 'state', line: 5, sequence: 0, rules: { required: true, max: 2, su_cc: { reverse: true } } },
        { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 5, sequence: 1, rules: 'required|su_postalcode|max:10|min:5', mask: '*****-****' }
      ],
      validate: false,
      display: []
    },
    countries: [
      {
        countryCode: 'US',
        name: 'United States',
        defaultCulture: 'en-us',
        billingAddressConfig: {
          fields: [
            { name: 'addressLine1', 'data-recurly': 'address1', type: 'text', line: 1, rules: { required: true, max: 30, su_cc: { reverse: true } } },
            { name: 'addressLine2', 'data-recurly': 'address2', type: 'text', line: 2, rules: { required: false, max: 30, su_cc: { reverse: true } } },
            { name: 'city', 'data-recurly': 'city', type: 'text', line: 4, rules: { required: true, max: 25, su_address: true, su_cc: { reverse: true } } },
            { name: 'region', type: 'state', 'data-recurly': 'state', line: 5, sequence: 0, rules: { required: true, max: 2, su_cc: { reverse: true } } },
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 5, sequence: 1, rules: 'required|su_postalcode|max:10|min:5', mask: '*****-****' }
          ],
          validate: false,
          display: []
        }
      },
      {
        countryCode: 'CA',
        name: 'Canada',
        defaultCulture: 'en-ca',
        billingAddressConfig: {
          fields: [
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 5, sequence: 1, rules: 'required|su_postalcode|max:7|min:7', mask: '*** ***' }
          ]
        }
      }
    ]
  },
  {
    region: 'EU',
    billingAddressConfig: {
      fields: [
        { name: 'addressLine1', 'data-recurly': 'address1', type: 'text', line: 1, rules: { required: true, max: 30, su_cc: { reverse: true } } },
        { name: 'addressLine2', 'data-recurly': 'address2', type: 'text', line: 2, rules: { required: false, max: 30, su_cc: { reverse: true } } },
        { name: 'city', 'data-recurly': 'city', type: 'text', line: 4, rules: { required: true, max: 25, su_address: true, su_cc: { reverse: true } } },
        { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 5, sequence: 1, rules: 'required|max:10|min:4' }
      ],
      validate: false,
      display: []
    },
    countries: [
      {
        countryCode: 'AT',
        defaultCulture: 'de-at',
        name: 'Österreich',
        billingAddressConfig: {
          fields: [
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 4, sequence: 0, rules: 'required|length:4|numeric', mask: '####' },
            { name: 'city', 'data-recurly': 'city', type: 'text', line: 4, sequence: 1, rules: { required: true, max: 25, su_address: true, su_cc: { reverse: true } } }
          ]
        }
      },
      {
        countryCode: 'DE',
        defaultCulture: 'de-de',
        name: 'Deutschland',
        billingAddressConfig: {
          fields: [
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 4, sequence: 0, rules: 'required|length:5', mask: '#####' },
            { name: 'city', 'data-recurly': 'city', type: 'text', line: 4, sequence: 1, rules: { required: true, max: 25, su_address: true, su_cc: { reverse: true } } }
          ]
        }
      },
      {
        countryCode: 'FR',
        defaultCulture: 'fr-fr',
        name: 'France',
        billingAddressConfig: {
          fields: [
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 4, sequence: 0, rules: 'required|length:5|su_frpostalcode|numeric', mask: '#####' },
            { name: 'city', 'data-recurly': 'city', type: 'text', line: 4, sequence: 1, rules: { required: true, max: 25, su_address: true, su_cc: { reverse: true } } }
          ]
        }
      },
      {
        countryCode: 'GB',
        name: 'United Kingdom',
        defaultCulture: 'en-gb',
        billingAddressConfig: {
          fields: [
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 5, sequence: 1, rules: 'required|min:6|max:8|su_postalcode|su_ukpostalcode' }
          ]
        }
      },
      {
        countryCode: 'IE',
        name: 'Ireland',
        defaultCulture: 'en-ie',
        billingAddressConfig: {
          fields: [
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 5, sequence: 1, rules: 'required|min:7|max:8|su_iepostalcode' }
          ]
        }
      },
      {
        countryCode: 'NL',
        defaultCulture: 'nl-nl',
        name: 'Netherlands',
        billingAddressConfig: {
          fields: [
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 4, sequence: 0, rules: 'required|length:7', mask: '#### @@' },
            { name: 'city', 'data-recurly': 'city', type: 'text', line: 4, sequence: 1, rules: { required: true, max: 25, su_address: true, su_cc: { reverse: true } } }
          ]
        }
      },
      {
        countryCode: 'BE',
        defaultCulture: 'de-be',
        name: 'Belgium',
        billingAddressConfig: {
          fields: [
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 4, sequence: 0, rules: 'required|su_be_postal', mask: '####' }
          ]
        }
      }
    ]
  },
  {
    region: 'SP',
    billingAddressConfig: {
      fields: [
        { name: 'addressLine1', 'data-recurly': 'address1', type: 'text', line: 1, rules: { required: true, max: 30, su_cc: { reverse: true } } },
        { name: 'addressLine2', 'data-recurly': 'address2', type: 'text', line: 2, rules: { required: false, max: 30, su_cc: { reverse: true } } },
        { name: 'city', 'data-recurly': 'city', type: 'text', line: 5, sequence: 0, rules: { required: true, max: 25, su_address: true, su_cc: { reverse: true } } },
        { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 5, sequence: 1, rules: 'required|length:4', mask: '####' }
      ],
      validate: false,
      display: []
    },
    countries: [
      {
        countryCode: 'AU',
        name: 'Australia',
        defaultCulture: 'en-au',
        billingAddressConfig: {
          fields: [
            { name: 'city', type: 'remove' },
            { name: 'suburb', 'data-recurly': 'city', type: 'text', line: 4, sequence: 0, rules: { required: true, max: 25, su_address: true, su_cc: { reverse: true } } },
            { name: 'region', type: 'state', 'data-recurly': 'state', line: 5, sequence: 0, rules: { required: true, max: 10, su_cc: { reverse: true } } },
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 5, sequence: 1, rules: 'required|length:4|numeric' }
          ]
        }
      },
      {
        countryCode: 'NZ',
        defaultCulture: 'en-nz',
        name: 'New Zealand',
        billingAddressConfig: {
          fields: [
            { name: 'postalCode', 'data-recurly': 'postal_code', type: 'text', line: 5, sequence: 1, rules: 'required|length:4|numeric' }
          ]
        }
      }
    ]
  }
]
